import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MessageSquare } from "lucide-react";

export default function SmsStatsCard() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/sms/stats?month=${month}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [month]);
  return (
    <div className="bg-white rounded-xl border p-5 space-y-3" data-testid="sms-stats-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-semibold text-[#0A2540] flex items-center gap-2"><MessageSquare className="h-4 w-4" /> SMS – přehled odeslání</h3>
        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500">Měsíc</span>
          <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-40 h-9" data-testid="sms-stats-month" />
        </div>
      </div>
      {d && !d.configured && <p className="text-sm text-amber-700" data-testid="sms-stats-unconfigured">SMS brána není nakonfigurována.</p>}
      {d && (
        <div className="flex flex-wrap gap-4 text-sm text-slate-700" data-testid="sms-stats-summary">
          <span>Odesláno: <b>{d.total_count}</b> SMS</span>
          <span>Útrata: <b>{d.total_cost.toFixed(2)} Kč</b></span>
          {d.credit && <span>Zůstatek kreditu: <b className={d.credit.credit < 200 ? "text-red-600" : ""} data-testid="sms-credit">{d.credit.credit.toFixed(2)} Kč</b> · cena {d.credit.smsPrice} Kč/SMS</span>}
        </div>
      )}
      {d && d.items.length > 0 && (
        <table className="w-full text-sm" data-testid="sms-stats-table">
          <thead className="text-slate-500"><tr><th className="text-left py-1 font-medium">SVJ</th><th className="text-right py-1 font-medium">SMS</th><th className="text-right py-1 font-medium">Částí</th><th className="text-right py-1 font-medium">Kč</th></tr></thead>
          <tbody>{d.items.map((i) => (
            <tr key={i.svj_id} className="border-t" data-testid={`sms-stats-row-${i.svj_id}`}>
              <td className="py-1">{i.svj_name}</td><td className="py-1 text-right">{i.count}</td><td className="py-1 text-right">{i.parts}</td><td className="py-1 text-right font-medium">{i.cost.toFixed(2)}</td>
            </tr>))}
          </tbody>
        </table>
      )}
      {d && d.items.length === 0 && <p className="text-sm text-slate-500" data-testid="sms-stats-empty">V tomto měsíci nebyly odeslány žádné SMS.</p>}
    </div>
  );
}
